module.exports = __webpack_public_path__ + "static/img/twjd-sde3.ddd2a6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde3.png
// module id = 839
// module chunks = 0